<template>
	<div class="view-review-results">
		<template v-if="reviewBaseInfo && !isShowDetail">
			<!-- 筛选top -->
			<el-form ref="topicListFormRef" :model="resultParams" label-width="80px">
				<el-row>
					<el-col :span="5">
						<el-form-item label="课题名称"><el-input clearable v-model="resultParams.name"></el-input></el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="所属区域">
							<el-cascader
								v-model="resultParams.regionName"
								:options="areaOptions"
								:props="{ expandTrigger: 'hover', checkStrictly: true, label: 'name', value: 'name' }"
								clearable
								filterable
								@change="cascaderChange"
							>
								<template slot-scope="{ node, data }">
									<span>{{ data.name }}</span>
									<span v-if="!node.isLeaf">({{ data.children.length }})</span>
								</template>
							</el-cascader>
							<!-- <el-input clearable v-model="resultParams.regionName"></el-input> -->
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="平均分">
							<el-input v-model="resultParams.minScore" style="width: 50px;"></el-input>
							<span style="margin: 0 10px;">~</span>
							<el-input v-model="resultParams.maxScore" style="width: 50px;"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="评审结果">
							<el-select v-model="resultParams.appraisalResult" clearable placeholder="请选择">
								<el-option v-for="item in reviewResultOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-button type="primary" @click="search">查询</el-button>
						<el-button type="success" @click="exportExcel">导出Excel</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="5">
						<el-form-item label="评审组">
							<el-select v-model="resultParams.groupInfoName" clearable placeholder="请选择">
								<el-option v-for="item in psGroupList" :key="item.id" :label="item.name" :value="item.name"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="conditionLeft"></div>
			<!-- 筛选前导出 -->
			<el-table
			v-show="isShow"
				id="table2"
				:header-cell-style="tableStyle"
				border
				ref="multipleTable"
				:data="resultList2"
				tooltip-effect="dark"
				style="width: 100%"
			>
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="name" label="课题名称" align="center" width="150">
					<template v-slot="scope">
						<div style="color: deepskyblue;cursor: pointer;" @click="viewTopicReviewDetail(scope.row)">{{ scope.row.name }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="unitName" label="单位" align="center"></el-table-column>
				<el-table-column prop="oneEmceeName" label="负责人姓名" align="center"></el-table-column>
				<el-table-column prop="groupInfoName" label="评审组" align="center"></el-table-column>
				<el-table-column v-for="(item,index) in tableHeader" :key="index" :label="item.tableName">
					<template slot-scope="scope" >
							<div v-for="(ele,indexs) in scope.row.tableResult">
						      	<span v-if="item.tableName == ele.tableName">{{ele.tableValue}}</span>
							</div>
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column prop="avgScore" label="平均分" sortable align="center"></el-table-column>
				<el-table-column prop="type" :label="reviewBaseInfo.reviewType == 0 ? '是否晋级到复评' : '是否晋级到终评'" align="center">
					<template slot-scope="scope">
						{{ getState(scope.row.type) }}
					</template>
				</el-table-column>
				<el-table-column prop="appraisalResult" label="评审结果" sortable align="center">
					<template slot-scope="scope">
						{{ calcReviewResult(scope.row) }}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template v-slot="scope">
						<el-button type="text" @click="viewTopicReviewDetail(scope.row)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			
			<!-- 筛选后导出 -->
			<el-table
				id="table"
				:header-cell-style="tableStyle"
				border
				ref="multipleTable"
				:data="resultList"
				tooltip-effect="dark"
				style="width: 100%"
				@selection-change="handleSelectionChange"
			>
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<!-- <el-table-column type="index" label="编号" width="50" align="center"></el-table-column> -->
				<el-table-column prop="name" label="课题名称" align="center" width="150">
					<template v-slot="scope">
						<div style="color: deepskyblue;cursor: pointer;" @click="viewTopicReviewDetail(scope.row)">{{ scope.row.name }}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="projectLevelName" label="课题级别" align="center"></el-table-column> -->
				<!-- <el-table-column prop="projectTypeName" label="课题类别" align="center"></el-table-column> -->
				<!-- <el-table-column prop="regionName" label="所属区域" align="center"></el-table-column> -->
				<el-table-column prop="unitName" label="单位" align="center"></el-table-column>
				<el-table-column prop="oneEmceeName" label="负责人姓名" align="center"></el-table-column>
				<el-table-column prop="groupInfoName" label="评审组" align="center"></el-table-column>
				<el-table-column v-for="(item,index) in tableHeader" :key="index" :label="item.tableName">
					<template slot-scope="scope">
						<div v-for="(ele,indexs) in scope.row.tableResult" :key="indexs">
						      <span v-if="item.tableName == ele.tableName">{{ele.tableValue}}</span>
						</div>
					</template>
				</el-table-column>
				</el-table-column>
				<el-table-column prop="avgScore" label="平均分" sortable align="center"></el-table-column>
				<el-table-column prop="type" :label="reviewBaseInfo.reviewType == 0 ? '是否晋级到复评' : '是否晋级到终评'" align="center">
					<template slot-scope="scope">
						{{ getState(scope.row.type) }}
					</template>
				</el-table-column>
				<el-table-column prop="appraisalResult" label="评审结果" sortable align="center">
					<template slot-scope="scope">
						{{ calcReviewResult(scope.row) }}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template v-slot="scope">
						<el-button type="text" @click="viewTopicReviewDetail(scope.row)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination
				style="text-align: center;margin-top: 20px;"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="resultParams.pageNumber"
				:page-sizes="[10, 35, 100]"
				:page-size="resultParams.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="resultTotal"
			></el-pagination>

			<div style="margin-top: 20px;" v-if="reviewBaseInfo.reviewState == 6">
				<button type="button" v-if="reviewBaseInfo.reviewType != 3" class="btn btn-info" style="margin-right: 20px;" @click="promotion">
					{{ reviewBaseInfo.reviewType == 0 ? '晋级到复评' : reviewBaseInfo.reviewType == 1 ? '晋级到终评' : '' }}
				</button>
				<button type="button" class="btn btn-info" @click="submitResult">结束评审</button>
			</div>
		</template>

		<template v-else>
			<h3 class="text-center">{{ topicInfo.name }}</h3>
			<div class="row row-reviewDetails">
				<div class="col-6 col-md-3">负责人姓名：{{ getAllEmcee }}</div>
				<div class="col-6 col-md-3">申报单位：{{ topicInfo.unitName }}</div>
				<div class="col-6 col-md-3">学段：{{ topicInfo.learningTypeName }}</div>
				<div class="col-6 col-md-3">领域：{{ topicInfo.researchFieName }}</div>
				<div class="col-6 col-md-3">预结题时间：{{ topicInfo.expectedClosingTime | getTime }}</div>
				<div class="col-6 col-md-3">学科：{{ topicInfo.disciplineName }}</div>
				<div class="col-6 col-md-3">专业技术职务：{{ topicInfo.professionalSkillPostName }}</div>
				<div class="col-6 col-md-3">学历：{{ topicInfo.lastDegreeId }}</div>
				<div class="col-6 col-md-3">学位：{{ topicInfo.lastQualificationId }}</div>
				<div class="col-6 col-md-3">研究专长：{{ topicInfo.areasSpecialization }}</div>
				<div class="col-6 col-md-3">出生日期：{{ topicInfo.birthTime | getTime }}</div>
				<div class="col-6 col-md-3">行政职务：{{ topicInfo.administrativeDuties }}</div>
				<div class="col-12">核心成员：{{ topicInfo.coreMember | getMember }}</div>
			</div>
			<!-- 审核文件列表 -->
			<ul class="file-list">
				<li class="file-item" :class="{ active: curFileTitleIndex === index }" v-for="(item, index) in fileTitleList" :key="index" @click="changeFileTitle(index)">{{ item }}</li>
			</ul>

			<!-- 在线浏览文档 -->
			<div class="view"><iframe ref="myIframe" height="100%" width="100%"></iframe></div>

			<!-- 专家评审详情 -->
			<div class="title">专家评审详情</div>
			<el-table :header-cell-style="tableStyle" :data="expertReviewTable" border style="width: 100%">
				<el-table-column key="b1" prop="userName" label="专家姓名"></el-table-column>
				<el-table-column key="b2" prop="type" label="评审意见">
					<template v-slot="scope">
						{{ scope.row.type === 0 ? '不建议立项' : scope.row.type === 1 ? '建议立项' : '' }}
					</template>
				</el-table-column>
				<el-table-column key="b3" prop="score" label="评分"></el-table-column>
				<el-table-column key="b4" prop="note" label="评语"></el-table-column>
			</el-table>

			<!-- <div class="form-group row mb-2">
				<div class="col-md-9 col-10"> -->
			<table class="table table-bordered table-centered mb-20 mt-4">
				<tbody>
					<tr>
						<th>评审组人数</th>
						<td>{{ topicInfo.groupNumber }}</td>
						<th>实到人数</th>
						<td>{{ topicInfo.actualArrivalNumber }}</td>
						<th>表决结果</th>
						<td>{{ topicInfo.result === null ? '' : topicInfo.result === 0 ? '不赞成' : '赞成' }}</td>
						<th>平均得分</th>
					</tr>
					<tr>
						<th>赞成票</th>
						<td>{{ topicInfo.endorseNumber }}</td>
						<th>反对票</th>
						<td>{{ topicInfo.disagreeNumber }}</td>
						<th>弃权票</th>
						<td>{{ topicInfo.waiverNumber }}</td>
						<td>{{ topicInfo.avgScore }}</td>
					</tr>
				</tbody>
			</table>
			<!-- </div>
				<div class="col-md-1 col-2"><span class="required"></span></div>
			</div> -->

			<!-- 审核意见列表 -->
			<!-- <div class="comments-list" v-if="topicInfo.schoolAuditList">
					<div class="form-group row mb-2" v-for="(item, index) in topicInfo.schoolAuditList" :key="index">
						<label class="col-md-2 col-12 col-form-label" style="text-align: right;">
							{{ item.auditType == 1 ? '区级审核' + (index + 1) : '学校审核' + (index + 1) }}
						</label>
						<div class="col-md-9 col-10">
							<table class="table table-bordered table-centered mb-0">
								<tbody>
									<tr>
										<th>审核意见</th>
										<td>{{ item.auditState == 2 ? '不通过' : item.auditState == 1 ? '通过' : '退回修改' }}</td>
										<th>审核人</th>
										<td>{{ item.auditName }}</td>
										<th>审核时间</th>
										<td>{{ item.createTime | getTime }}</td>
									</tr>
									<tr>
										<th>审核说明</th>
										<td colspan="5">{{ item.auditExplain }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="col-md-1 col-2"><span class="required"></span></div>
					</div>
				</div> -->

			<div class="btn_wrap"><el-button type="primary" @click="isShowDetail = false">返回</el-button></div>
		</template>
	</div>
</template>

<script>
import {
	getGroupListByReviewId,
	getReviewResult,
	topicPromotion,
	submitReviewResult,
	getReviewBaseInfoById,
	getTopicReviewResultDetailById
} from '@/api/after/expertReviewSettings.js';
import FileSaver from 'file-saver';
import { getAreaTree } from '@/api/after/systemManagement';
import XLSX from 'xlsx';
export default {
	data() {
		return {
			isShow:false,
			tableHeader: [],
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			reviewResultOptions: [
				{
					label: '不建议',
					value: 0
				},
				{
					label: '建议',
					value: 1
				},
				{
					label: '未评',
					value: 2
				}
			],
			options: [],
			resultList: [], //结果列表
			resultList2:[], //筛选后
			resultTotal: 0,
			resultParams: {
				appraisalResult: null,
				maxScore: null,
				minScore: null,
				id: 0,
				name: '',
				pageNumber: 1,
				pageSize: 10,
				regionName: '',
				groupInfoName: ''
			},
			multipleVal: [],
			reviewBaseInfo: null,
			topicInfo: {},
			curFileTitleIndex: 0,
			fileTitleList: ['课题申请书', '匿名评审活页'],
			isShowDetail: false,
			tableStyle: {
				textAlign: 'center',
				backgroundColor: '#5172c5',
				color: '#ffffff'
			},
			expertReviewTable: [],
			areaOptions: [],
			valGroup: '',
			psGroupList: []
		};
	},
	filters: {
		getMember(val) {
			if (val) {
				return val.replace(/,/g, '、');
			}
		}
	},
	computed: {
		getState(val) {
			return val => {
				if (val) {
					if (this.reviewBaseInfo) {
						if (this.reviewBaseInfo.reviewType == 0) {
							//初评阶段
							if ([7, 8, 9, 10, 11].includes(val)) {
								return '未晋级';
							} else {
								return '已晋级';
							}
						} else if (this.reviewBaseInfo.reviewType == 1) {
							//抚平阶段
							if ([12, 13, 14, 15, 16].includes(val)) {
								return '未晋级';
							} else {
								return '已晋级';
							}
						}
					}
				} else {
					return '';
				}
			};
		},
		// 获取评审结果
		calcReviewResult(val) {
			return val => {
				if (val) {
					if (val.avgScore) {
						if (val.appraisalResult == 1) {
							return '建议立项';
						} else if (val.appraisalResult === null) {
							return '无结果';
						} else if (val.appraisalResult == 0) {
							return '不建议立项';
						}
					} else {
						return '未评';
					}
				}
			};
		},
		getAllEmcee() {
			if (Object.keys(this.topicInfo).length) {
				if (this.topicInfo.twoEmceeName) {
					return `${this.topicInfo.oneEmceeName}、${this.topicInfo.twoEmceeName}`;
				} else {
					return this.topicInfo.oneEmceeName;
				}
			}
		}
	},
	created() {
		this.getReviewResult();
		this.getReviewResult2()
		this.getReviewBaseInfoById();
		this.getAreaTree();
		this.getGroupListByReviewId(this.$route.query.reviewId);
	},
	methods: {
		// 获取分组列表
		async getGroupListByReviewId(id) {
			const res = await getGroupListByReviewId(id);
			if (res.code == 200) {
				this.psGroupList = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		getAreaTree() {
			getAreaTree().then(res => {
				if (res.code == 200) {
					this.areaOptions = res.data;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		//区域查询
		cascaderChange(e) {
			if (e) {
				if (e[1]) {
					this.resultParams.regionName = e[1];
				} else {
					this.resultParams.regionName = e[0];
				}
			} else {
				this.resultParams.regionName = '';
			}
		},
		handleSizeChange(val) {
			this.resultParams.pageSize = val;

			this.getReviewResult();
		},
		handleCurrentChange(val) {
			this.resultParams.pageNumber = val;
			this.getReviewResult();
		},
		// 查看评审结果详情
		async viewTopicReviewDetail(data) {
			let params = {
				declareId: data.id,
				groupId: data.groupId
			};
			await this.getTopicReviewDetail(params);
			this.isShowDetail = true;
			this.$nextTick(() => {
				this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.declarationContents}`);
			});
		},
		// 获取课题评审详情
		async getTopicReviewDetail(params) {
			const res = await getTopicReviewResultDetailById(params);
			if (res.code == 200) {
				this.topicInfo = res.data;
				// 赋值专家评审详情列表数据
				this.expertReviewTable = this.topicInfo.auditList;
				// 判断是否有匿名评审页
				if (!this.topicInfo.anonymousReview) {
					this.fileTitleList = ['课题申请书'];
				}
			} else {
				this.$message.error(res.data);
			}
		},
		// 改变文件标题索引
		changeFileTitle(index) {
			this.curFileTitleIndex = index;
			if (index == 0) {
				this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.declarationContents}`);
			} else {
				this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.anonymousReview}`);
			}
		},
		// 根据评审ID获取评审基本信息
		async getReviewBaseInfoById() {
			const res = await getReviewBaseInfoById(this.$route.query.reviewId);
			if (res.code == 200) {
				this.reviewBaseInfo = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		search() {
			this.resultParams.pageNumber = 1;
			this.getReviewResult();
		},
		// 导出Excel列表
		exportExcel() {
			if(this.resultParams.maxScore || this.resultParams.minScore || this.resultParams.regionName || this.resultParams.groupInfoName || this.resultParams.appraisalResult || this.resultParams.name){
				var xlsxParam = { raw: true };
				var wb = XLSX.utils.table_to_book(document.querySelector('#table'), xlsxParam);
				var wbout = XLSX.write(wb, {
					bookType: 'xlsx',
					bookSST: true,
					type: 'array'
				});
				try {
					FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '评审结果.xlsx');
				} catch (e) {
					if (typeof console !== 'undefined') {
						console.log(e, wbout);
					}
				}
				return wbout;
				console.log('筛选后');
			}else{
				var xlsxParam = { raw: true };
				var wb = XLSX.utils.table_to_book(document.querySelector('#table2'), xlsxParam);
				var wbout = XLSX.write(wb, {
					bookType: 'xlsx',
					bookSST: true,
					type: 'array'
				});
				try {
					FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '评审结果.xlsx');
				} catch (e) {
					if (typeof console !== 'undefined') {
						console.log(e, wbout);
					}
				}
				return wbout;
				console.log('筛选前');
			}
		},
		// 表格多选
		handleSelectionChange(val) {
			console.log('多选', val);
			this.multipleVal = val;
		},
		//筛选前
		async getReviewResult2(){
			let params = {
				id:this.$route.query.reviewId,
				pageNumber:1,
				pageSize:9999
			}
			const res = await getReviewResult(params);
			if (res.code == 200) {
				this.resultList2 = [];
				this.resultList2 = res.data.records;
				let maxNum = null;
				let arr = [];
				if (this.resultList2.length > 0) {
					this.resultList2.forEach(item => {
						arr.push(item.tableResult.length);
						maxNum = arr.sort().slice(-1)[0];
					});
					this.resultList2.forEach(item2 => {
						if (item2.tableResult.length === maxNum) {
							this.tableHeader = item2.tableResult;
						}
					});
				}
			}
			console.log(this.resultList2 ,'筛选前');
		},
		// 获取评审结果
		async getReviewResult() {
			this.resultParams.id = +this.$route.query.reviewId;
			const res = await getReviewResult(this.resultParams);
			if (res.code == 200) {
				this.resultList = [];
				this.resultList = res.data.records;
				this.resultTotal = res.data.total;
				let maxNum = null;
				let arr = [];
				if (this.resultList.length > 0) {
					this.resultList.forEach(item => {
						arr.push(item.tableResult.length);
						maxNum = arr.sort().slice(-1)[0];
					});
					this.resultList.forEach(item2 => {
						if (item2.tableResult.length === maxNum) {
							this.tableHeader = item2.tableResult;
							console.log(this.tableHeader, '表头');
						}
					});
				}
			}
		},
		// 晋级
		promotion() {
			this.$confirm('确定要将选择的课题晋级吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let params = {
						ids: [],
						reviewType: +this.reviewBaseInfo.reviewType + 1
					};
					if (this.multipleVal.length === 0) {
						this.$message.error('请选择要晋级的课题！');
						return;
					}
					params.ids = this.multipleVal.map(item => {
						return item.id;
					});
					this.topicPromotion(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
		},
		// 课题晋级接口
		async topicPromotion(data) {
			const res = await topicPromotion(data);
			if (res.code == 200) {
				this.$message.success('晋级成功！');
				this.getReviewResult();
			} else {
				this.$message.error(res.data);
			}
		},
		// 提交评审结果
		submitResult() {
			this.$confirm('确定要结束本次评审活动吗？结束后所有信息不允许再修改!', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let ids = this.resultList.map(item => {
						return item.id;
					});
					let params = {
						groupId: this.$route.query.reviewId,
						ids
					};
					this.submitReviewResult(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		// 提交评审结果接口
		async submitReviewResult(data) {
			const res = await submitReviewResult(data);
			if (res.code == 200) {
				this.$message.success('提交评审结果成功！');
				this.$emit('finish');
			}
		}
	}
};
</script>

<style scoped lang="scss">
.title {
	font-size: 18px;
	margin: 15px 0;
	text-align: center;
	font-weight: bold;
}
.btn_wrap {
	text-align: center;
}
.view {
	width: 1000px;
	height: 500px;
	margin: 0 auto;
}
.comments-list {
	margin-top: 20px;
}
.file-list {
	width: 100%;
	display: flex;
	justify-content: center;
	padding-left: 0;
	list-style: none;
	.file-item {
		font-size: 24px;
		text-align: center;
		width: 50%;
		border-bottom: 2px solid #eee;
		cursor: pointer;
	}
}
.file-item.active {
	border-color: #00a2e8;
}
</style>
